// uses ./searchField.less
import PropTypes from 'prop-types';

import React from 'react';
import { connect } from 'react-redux';
import debounce from 'lodash/debounce';
import { searchChange, requestTrigger } from './appsListFiltersActionCreators';

const SearchField = (props) => (
    <div className="searchbar">
        <input
            className="search-text"
            type="text"
            name="search"
            placeholder="Search"
            value={props.search}
            onChange={props.dispatchSearchChange}
        />
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
        <button type="button" onClick={props.dispatchRequestTrigger}>
            <i className="zmdi zmdi-search" />
        </button>
    </div>
);

SearchField.propTypes = {
    search: PropTypes.string.isRequired,
    dispatchSearchChange: PropTypes.func.isRequired,
    dispatchRequestTrigger: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => {
    const dispatchRequestTrigger = () => dispatch(requestTrigger());
    const dispatchRequestTriggerDebounced = debounce(() => {
        dispatch(requestTrigger());
    }, 1000);

    return {
        dispatchSearchChange: (e) => {
            dispatch(searchChange(e.target.value));
            dispatchRequestTriggerDebounced();
        },
        dispatchRequestTrigger,
    };
};

export default connect(null, mapDispatchToProps)(SearchField);
